/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  viewportPropType,
  LARGE_VIEWPORT
} from "@template/state/modules/layout";
import Spinner from "@template/components/Spinner";
import { isWindowDefined } from "@src/helpers/url";
import { getDesktopTemplate } from "@template/helpers/navigationTemplatesResolver";
import globalEventHandler, { events, keys } from "@template/globalEventHandler";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

const inferTemplateComponent = item => {
  const { largeScreenTemplateId: id } = item;
  const TemplateComponent = getDesktopTemplate(id);

  return <TemplateComponent item={item} />;
};

class LargeSecondaryNavigation extends Component {
  isVisible = () =>
    this.props.item.id === this.props.largeNavActiveItemId &&
    this.props.viewport === LARGE_VIEWPORT;

  globalTrackingTimer = null;

  componentDidMount() {
    const { hasClickedInside, clearNavActiveItem } = this.props;

    this.globalClickListener = globalEventHandler.addListener(
      events.click,
      event => {
        if (this.isVisible() && !hasClickedInside(event)) {
          clearNavActiveItem();
        }
      }
    );

    this.globalKeyDownListener = globalEventHandler.addListener(
      events.keyDown,
      event => {
        if (this.isVisible() && event.key === keys.escape) {
          clearNavActiveItem();
        }
      }
    );
  }

  componentWillUnmount() {
    this.globalClickListener && this.globalClickListener.remove();
    this.globalKeyDownListener && this.globalKeyDownListener.remove();
  }

  renderHeading = item => {
    if (!item || (item && !item.label)) return null;
    const id = createIdAriaDescribedBy(item.label);

    return (
      <h2 id={id} className={styles.columnHeader}>
        <span>{item.label}</span>
      </h2>
    );
  };

  renderContainer = item => {
    const { largeScreenStyleType, largeScreenColumnSpan } = item;
    const showHeading = largeScreenStyleType !== "noTitle";

    return (
      <li
        key={item.id}
        className={cx(
          styles.column,
          styles[`colspan-${largeScreenColumnSpan || 1}`]
        )}
      >
        {showHeading && this.renderHeading(item)}
        {inferTemplateComponent(item)}
      </li>
    );
  };

  render() {
    const { item, clearNavActiveItem } = this.props;
    const classes = cx(styles.container, {
      [styles.visible]: this.isVisible()
    });

    const hasNoItems = !item.items.length;

    //The window type checking is a work around to
    //make the classes match server and client side
    const flyoutClasses = cx(styles.flyout, {
      [styles.isLoading]: hasNoItems || !isWindowDefined()
    });

    return (
      <div
        className={classes}
        data-testid="secondarynav-container"
        ref={c => (this.container = c)}
      >
        <div
          className={styles.backdrop}
          onClick={clearNavActiveItem}
          onMouseMove={clearNavActiveItem}
          aria-hidden="true"
          data-testid="backdrop"
        />
        <div className={styles.flyoutContainer}>
          <ul
            role="list"
            className={flyoutClasses}
            data-id={item.id}
            data-testid="secondarynav-flyout"
          >
            {hasNoItems ? (
              <Spinner size="x-large" />
            ) : (
              item.items.map(this.renderContainer)
            )}
          </ul>
        </div>
      </div>
    );
  }

  static propTypes = {
    item: navigationPropType.isRequired,
    largeNavActiveItemId: PropTypes.string,
    setNavActiveItem: PropTypes.func.isRequired,
    clearNavActiveItem: PropTypes.func.isRequired,
    buttonElement: PropTypes.object,
    viewport: viewportPropType.isRequired,
    hasClickedInside: PropTypes.func.isRequired
  };
}

export default LargeSecondaryNavigation;
